module.exports = __webpack_public_path__ + "static/media/Exo-Bold.a939d1d0.ttf";